import { StateService } from '@uirouter/angular';
import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { AdminService } from '../../../../../core/services/core.admin.service';
import { ProjectModel } from '../../../../../core/services/project.model.service';

@Component({
  selector: 'tracker-admin-main',
  template: require('./admin.main.component.html')
})
export class TrackerAdminMainComponent implements OnInit {
  @Input() project: any;
  @Input() tracker: any;
  @Input() siteConfig: any;
  @Input() validationErrors: any;

  hostName: string;
  siteAutosearch: boolean;
  autosearch: number;
  tiAutoMonitor: number;
  autoCloseStatus: any;
  roles: any[] = [];
  selectedRoles: Array<any> = [];
  rolesLabel: string | false = false;

  constructor(
      private adminService: AdminService,
      private projectModel: ProjectModel,
      private stateService: StateService
  ) {}

  ngOnInit() {
    this.hostName = _.get(this.siteConfig, 'hostName', '');
    this.siteAutosearch = _.get(this.siteConfig, 'tiaAutosearch', false);

    if (this.siteAutosearch) {
      this.adminService.getConfig('tracker', this.tracker.id, 'autosearch', 1)
        .then(response => {
          this.autosearch = Number(_.get(response, 'settingValue', 1));
        });
    }

    this.adminService.getConfig('tracker', this.tracker.id, 'automonitor', 0)
      .then(response => {
        this.tiAutoMonitor = Number(_.get(response, 'settingValue', 0));
      });

    if (this.tracker.trackerType == 3) {
      this.setAutoCloseStatus();
    }
    this.projectModel.loadProjectRoles(this.stateService.params.unixName)
        .then((data: any) => {
          this.roles =  data;
        });
    this.selectedRoles = _.get(this.tracker, 'autoAssignToRoles', []);
    this.rolesLabel = this.getRolesLabel();
  }

  toggleBoolean(path: string) {
    if (!_.has(this.tracker, path) || typeof _.get(this.tracker, path) !== 'boolean') {
      return;
    }

    const val = _.get(this.tracker, path);
    _.set(this.tracker, path, !val);
  }

  toggleYN(path: string) {
    if (!_.has(this.tracker, path)) {
      return;
    }

    let val = _.get(this.tracker, path);
    val = (val === 'Y') ? 'N' : 'Y';
    _.set(this.tracker, path, val);
  }

  toggleAutosearch() {
    this.autosearch = this.autosearch ? 0 : 1;
    this.adminService.postConfig({ section: 'tracker', refId: this.tracker.id, settingName: 'autosearch', settingValue: this.autosearch });
  }

  toggleTiAutoMonitor() {
    this.tiAutoMonitor = this.tiAutoMonitor ? 0 : 1;
    this.adminService.postConfig({ section: 'tracker', refId: this.tracker.id, settingName: 'automonitor', settingValue: this.tiAutoMonitor });
  }

  selectAutoCloseStatus(statusElement: any) {
    this.autoCloseStatus = statusElement;
    this.tracker.settings.autoClose.status = statusElement.id;
  }

  private setAutoCloseStatus() {
    const statusId = _.get(this.tracker, 'settings.autoClose.status', 0);
    const statusElement = _.find(_.get(this.tracker, 'fields.status.fieldElements', []), { id: statusId });

    if (!_.isEmpty(statusElement)) {
      this.autoCloseStatus = statusElement;
    } else {
      this.autoCloseStatus = { id: 0, label: "None" };
    }
  }
  protected hasRole(role: any): boolean {
    return _.find(this.selectedRoles, (r) => r.id === role.id) !== undefined;
  }

  protected toggleRole(role: any): void {
    if (!Array.isArray(this.selectedRoles)) {
      this.selectedRoles = [];
    }
    const index = this.selectedRoles.findIndex(r => r.id === role.id);

    if (index > -1) {
      this.selectedRoles = this.selectedRoles.filter(r => r.id !== role.id);
    } else {
      this.selectedRoles = _.concat(this.selectedRoles, role);
    }

    this.rolesLabel = this.getRolesLabel();
    this.tracker.autoAssignToRoles = this.selectedRoles;
  }

  private getRolesLabel(): string | false {
    const len = _.get(this.selectedRoles, 'length', 0);
    if (len === 0) {
      return false;
    }
    if (len < 4) {
      return _.map(this.selectedRoles, 'roleName').join(',');
    }
    return `${this.selectedRoles.length} roles`;
  }
  hasValidationFailure(fieldName, validationType) {
    var field = _.get(this.validationErrors, fieldName, false);
    
    if (field) {
        if (validationType) {
            // Look for the specific validation type for the named field
            // field can be an object or an array (for multiple validations on a field)
            if (Array.isArray(field)) {
                return (undefined !== _.find(field, { 'type': validationType }));
            } else {
                return (_.has(field, 'type'));
            }
        }

        // field can be an object or an array (for multiple validations on a field)
        return (Array.isArray(field) && _.size(field) > 0) || (_.has(field, 'type'));
    }
    
    return false;
}
}
